window.Products.Clothing.MiniShorts = function() {
};
window.Products.Clothing.MiniShorts.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.MiniShorts.id = 62;
window.Products.Clothing.MiniShorts.slug = 'mini-shorts';
window.Products.Clothing.MiniShorts.has_3d = true;
window.Products.Clothing.MiniShorts.dpi = 150;

window.Products.Clothing.MiniShorts.prototype.set3dProperties = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.map.minFilter = THREE.LinearMipMapLinearFilter;
    modelViewer.object.children[0].material.needsUpdate = true; //Force update the material with the design
    modelViewer.object.children[0].material.color = new THREE.Color(0.748900, 0.748900, 0.748900);
    
    if(typeof modelViewer.object.children[1] !== 'undefined') {
        modelViewer.object.children[1].material.map = modelViewer.texture;
        modelViewer.object.children[1].material.map.minFilter = THREE.LinearMipMapLinearFilter;
        modelViewer.object.children[1].material.needsUpdate = true; //Force update the material with the design
        
        //Fade color using a combination of color and emissive (we might implement a custom shader eventually)
        modelViewer.object.children[1].material.color = new THREE.Color(0.3,0.3,0.3);
        modelViewer.object.children[1].material.emissive = new THREE.Color(0.6,0.6,0.6);
    }

    modelViewer.object.position.y = 0.03;
    modelViewer.camera.position.y = 0.1;
    modelViewer.camera.position.z = 1;
    modelViewer.initalCameraPosition.z = -1;
};

window.Products.Clothing.MiniShorts.prototype.setThreeControls = function(controls) {
    controls.minDistance = 1.3;
    controls.maxDistance = 1.7;
};

window.Products.Clothing.MiniShorts.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
};